export class VerificationDigitCalculator {
    static calculateVerificationDigit(identificationNumber: string): string {
        if (!/^\d+$/.test(identificationNumber)) {
            throw new Error('Identification number must be numeric');
        }

        const paddedIdentificationNumber = identificationNumber.padStart(9, '0');
        const digits = paddedIdentificationNumber.split('').map(Number);
        const weightSeries = process.env.REACT_APP_VERIFICATION_DIGIT_NUM_SERIES;
        const weightSeriesArray = weightSeries?.split(',').map(Number);

        if (!weightSeriesArray || weightSeriesArray.length !== 9) {
            throw new Error('Invalid weight series');
        }

        let multiplicationResult = 0;
        for (let i = 0; i < weightSeriesArray.length; i++) {
            multiplicationResult += weightSeriesArray[i] * digits[i];
        }

        const divisionRemainder = multiplicationResult % 11;
        let result = divisionRemainder;

        if (divisionRemainder > 1) {
            result = 11 - divisionRemainder;
        }

        return result.toString();
    }
}
